import styled from 'styled-components'
import MinusOIcon from '@pc/components/Works/Panel/shared/Icons/MinusOIcon'

const ListCloseIconBase = styled(MinusOIcon)`
  color: #ed2d2d;
  height: 18px;
  width: 18px;
`

const ListCloseIcon = () => <ListCloseIconBase width={18} height={18} />

export default ListCloseIcon
